//  const backEndDomain = "http://localhost:8080";

const backEndDomain = process.env.REACT_APP_BACKEND;


const summaryApi = {
  // Auth

  signUp: {
    url: `${backEndDomain}/api/auth/register`,
    method: "post",
  },
  signIn: {
    url: `${backEndDomain}/api/auth/login`,
    method: "post",
  },
  logOut: {
    url: `${backEndDomain}/api/auth/logout`,
    method: "post",
  },

  // user

  currentUser: {
    url: `${backEndDomain}/api/user/user-details`,
    method: "get",
  },
  users: {
    url: `${backEndDomain}/api/user/users`,
    method: "get",
  },
  editUser: (id) => ({
    url: `${backEndDomain}/api/user/edit-user/${id}`,
    method: "patch",
  }),
  deleteUser: (id) => ({
    url: `${backEndDomain}/api/user/delete-user/${id}`,
    method: "delete",
  }),

  // product
  addProduct: {
    url: `${backEndDomain}/api/product/add-product`,
    method: "post",
  },
  getAllProducts: {
    url: `${backEndDomain}/api/product/get-all-products`,
    method: "get",
  },
  deleteProduct: (id) => ({
    url: `${backEndDomain}/api/product/delete-product/${id}`,
    method: "delete",
  }),
  editProduct: (id) => ({
    url: `${backEndDomain}/api/product/edit-product/${id}`,
    method: "patch",
  }),
  getProductDetails: (id) => ({
    url: `${backEndDomain}/api/product/get-product/${id}`,
    method: "get",
  }),
  getCategoryProduct: {
    url: `${backEndDomain}/api/product/get-category-product`,
    method: "get",
  },
  categoryWiseProduct: {
    url: `${backEndDomain}/api/product/category-wise-product`,
    method: "post",
  },
  addToCart: {
    url: `${backEndDomain}/api/user/add-to-cart`,
    method: "post",
  },
  cartProductCount: {
    url: `${backEndDomain}/api/user/cart-product-count`,
    method: "get",
  },
  cartProductList: {
    url: `${backEndDomain}/api/user/cart-data`,
    method: "get",
  },
  updateCartProduct: {
    url: `${backEndDomain}/api/user/update-cart`,
    method: "post",
  },
  deleteCartProduct: {
    url: `${backEndDomain}/api/user/delete-cart`,
    method: "delete",
  },
  SearchCartProduct: {
    url: `${backEndDomain}/api/product/search-products?query=`,
    method: "get",
  },
  paymentOrder: {
    url: `${backEndDomain}/api/payment/checkout`,
    method: "post",
  },
  getOrder: {
    url: `${backEndDomain}/api/payment/order`,
    method: "get",
  },
  getAllOrders: {
    url: `${backEndDomain}/api/payment/all-orders`,
    method: "get",
  },
  addToWishlist: {
    url: `${backEndDomain}/api/user/add-to-wishlist`,
    method: "post",
  },
  wishlistProductList: {
    url: `${backEndDomain}/api/user/wishlist-data`,
    method: "get",
  },
  deleteWishlistProduct: {
    url: `${backEndDomain}/api/user/delete-wishlist`,
    method: "delete",
  },
};
export default summaryApi;
